import { useEffect, useState } from 'react';
import fetchInfo from '../../../util/fetchModalData';
import EirActionModal from '../eir-action-modal/EirActionModal';

// this modal will be removed, when webchat is available to integrate
const EirExisitingCustomerModal = ({ existingCustomerModal, redirectToWebchat }) => {
  const [cmsData, setCmsData] = useState({});
  const [load, setLoad] = useState(true);

  const getCollectionData = async () => {
    try {
      const data = await fetchInfo({
        collectionType: 'eir-action-modals',
        modalID: 'MW-eirMobile_existing_customer_check',
      });
      if (Object?.keys(data).length !== 0) {
        setLoad(false);
        setCmsData(data);
      }
    } catch (error) {
      console.error('error', error);
    }
  };

  useEffect(() => {
    getCollectionData();
  }, []);
  return (
    <EirActionModal
      id={cmsData?.attributes?.modalID}
      open={existingCustomerModal.value}
      handleClose={existingCustomerModal.disable}
      title={cmsData?.attributes?.title}
      description={`${
        cmsData?.attributes?.firstHalfDescription ? cmsData?.attributes?.firstHalfDescription : ''
      }
      ${
        cmsData?.attributes?.secondHalfDescription ? cmsData?.attributes?.secondHalfDescription : ''
      }
      `}
      cta={[{ text: 'Ok', type: 'contained', action: () => redirectToWebchat() }]}
      disableCloseOnBackdropClick
      disableCloseOnEscapeKeyDown
      disablecta={false}
      load={load}
    />
  );
};

export default EirExisitingCustomerModal;
